/**
 * Web service for converting a longitude, latitude pair to the nearest
 * postal address.
 *
 * Example output:
 *
 * curl https://api.dataforsyningen.dk/adgangsadresser/reverse\?x\=574380.9209504016\&y\=6228272.66888137\&srid\=25832\&struktur\=mini
 *
 * {
    "id": "0a3f5096-a6ae-32b8-e044-0003ba298018",
    "status": 1,
    "darstatus": 3,
    "vejkode": "6033",
    "vejnavn": "Næringen",
    "adresseringsvejnavn": "Næringen",
    "husnr": "34",
    "supplerendebynavn": null,
    "postnr": "8240",
    "postnrnavn": "Risskov",
    "stormodtagerpostnr": null,
    "stormodtagerpostnrnavn": null,
    "kommunekode": "0751",
    "x": 574364.25,
    "y": 6228262,
    "href": "https://api.dataforsyningen.dk/adgangsadresser/0a3f5096-a6ae-32b8-e044-0003ba298018",
    "betegnelse": "Næringen 34, 8240 Risskov"
  }
 */
import { WebServiceClient } from '../WebServiceClient'

export interface AddressReverseResult {
  id: string
  vejnavn?: string
  husnr?: string
  postnr?: string
  postnrnavn?: string
  betegnelse?: string
}

export class AddressReverse extends WebServiceClient {
  static get URL (): string { return 'https://api.dataforsyningen.dk/adgangsadresser/reverse' }

  constructor () {
    const defaultParams = {
      srid: '25832',
      noFormat: '',
      struktur: 'mini'
    }
    super(AddressReverse.URL, defaultParams)
  }

  setCoords (coords: number[]): void {
    if (coords.length !== 2) {
      throw new Error('Parameter coords must have exactly two items.')
    }
    this.addParam('x', coords[0].toString())
    this.addParam('y', coords[1].toString())
  }

  async fetchReverseAddress (): Promise<AddressReverseResult> {
    const response: Response = await fetch(this.url())
    if (!response.ok) {
      throw new Error('Got invalid HTTP response.')
    }

    return await response.json()
  }
}
